<template>
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M37.7767 26.2466C37.0426 25.4278 36.0591 24.7525 35.6591 24.5172V6.41168C35.6591 5.98816 35.3768 5.88228 35.2356 5.88228H27.8946V6.94108C27.8946 7.9293 27.1181 8.36459 26.7299 8.4587H15.083C14.236 8.2893 13.9301 7.54107 13.883 7.18814V5.91757H6.50672C6.13966 5.91757 6.09496 6.17639 6.11849 6.3058V39.6228C6.09025 39.9052 6.27143 40.0934 6.36555 40.1522H35.1297C35.5532 40.124 35.6591 39.9052 35.6591 39.7993V39.3758L37.5297 41.2463C36.9085 42.2628 35.765 42.3993 35.2709 42.3404H6.36555C4.41735 42.3404 3.97735 40.9052 4.00088 40.1875V5.91757C3.97264 4.19525 5.3538 3.71762 6.0479 3.69409L13.883 3.72938C13.7983 2.43058 14.6477 2.03529 15.083 2H26.7299C27.5204 2.14117 27.8357 2.85881 27.8946 3.19998V3.69409H36.1179C37.3603 4.0329 37.7414 5.05877 37.7767 5.52935V26.2466Z" />
    <rect
      x="9.0127"
      y="26.6348"
      width="12.5645"
      height="2.11761"
      rx="1.0588"
    />
    <rect
      x="9.0127"
      y="29.9524"
      width="12.5645"
      height="2.11761"
      rx="1.0588"
    />
    <rect
      x="9.0127"
      y="33.4818"
      width="12.5645"
      height="2.11761"
      rx="1.0588"
    />
    <rect
      x="35.5"
      y="34.6156"
      width="8.46744"
      height="2.11761"
      rx="1.0588"
      transform="rotate(45.0282 35.5 34.6156)"
    />
    <path d="M23.377 10.4352C23.871 10.3764 25.0432 10.5126 25.7773 11.5289L28.6709 15.2701H30.4717C30.9306 15.3997 31.8902 15.9062 32.0596 16.8942V19.9996C31.989 20.5408 31.4453 21.595 29.8359 21.4821C29.8712 20.4586 29.2572 18.3337 26.5186 18.0231C25.4245 18.0113 23.2146 18.6868 23.1299 21.4821H18.1182C18.1417 20.4233 17.5115 18.0582 14.7656 18.0582C12.0127 18.0582 11.3418 20.2585 11.3418 21.4821H10.3535C9.90636 21.3525 9.01277 20.8677 9.0127 19.9645V17.0699C9.04813 16.5875 9.40823 15.5594 10.5654 15.3053H12.0127L15.0479 11.4586C15.3302 11.0704 16.1634 10.3222 17.2363 10.4352H23.377ZM18.0127 12.2701C17.648 12.2231 16.7845 12.2709 16.248 12.8356L14.4482 15.2701H19.4238V12.2701H18.0127ZM22.7061 12.2487H21.2949V15.2487H26.2715L24.4707 12.8131C23.9342 12.2488 23.0707 12.2016 22.7061 12.2487Z" />
    <path d="M17.0596 21.4819C17.0596 22.7294 16.0483 23.7407 14.8008 23.7407C13.5533 23.7407 12.542 22.7294 12.542 21.4819C12.542 20.2344 13.5533 19.2231 14.8008 19.2231C16.0483 19.2231 17.0596 20.2344 17.0596 21.4819ZM13.5588 21.4819C13.5588 22.1678 14.1149 22.7239 14.8008 22.7239C15.4867 22.7239 16.0427 22.1678 16.0427 21.4819C16.0427 20.796 15.4867 20.24 14.8008 20.24C14.1149 20.24 13.5588 20.796 13.5588 21.4819Z" />
    <path d="M28.7768 21.4819C28.7768 22.7294 27.7655 23.7407 26.5181 23.7407C25.2706 23.7407 24.2593 22.7294 24.2593 21.4819C24.2593 20.2344 25.2706 19.2231 26.5181 19.2231C27.7655 19.2231 28.7768 20.2344 28.7768 21.4819ZM25.2761 21.4819C25.2761 22.1678 25.8321 22.7239 26.5181 22.7239C27.204 22.7239 27.76 22.1678 27.76 21.4819C27.76 20.796 27.204 20.24 26.5181 20.24C25.8321 20.24 25.2761 20.796 25.2761 21.4819Z" />
    <path d="M38.9414 31.717C38.9414 35.8104 35.6231 39.1287 31.5298 39.1287C27.4365 39.1287 24.1182 35.8104 24.1182 31.717C24.1182 27.6237 27.4365 24.3054 31.5298 24.3054C35.6231 24.3054 38.9414 27.6237 38.9414 31.717ZM26.9731 31.717C26.9731 34.2336 29.0132 36.2737 31.5298 36.2737C34.0464 36.2737 36.0865 34.2336 36.0865 31.717C36.0865 29.2005 34.0464 27.1604 31.5298 27.1604C29.0132 27.1604 26.9731 29.2005 26.9731 31.717Z" />
  </svg>

</template>

<script>
  export default {}
</script>
